<template>

    <div>
        <v-row>
            <v-col class="py-0" cols="12" lg="6">
                <fixture-item
                        class="mx-auto"
                        v-for="(game, index) in weekGamesOne"
                        :key="game.id"
                        :game="game"
                        :index="index"
                        :games="weekGames"
                ></fixture-item>
            </v-col>
            <v-col class="py-0 pr-lg-8" cols="12" lg="6">
                <fixture-item
                        class="mx-auto"
                        v-for="(game, index) in weekGamesTwo"
                        :key="game.id"
                        :game="game"
                        :index="index"
                        :games="weekGames"
                ></fixture-item>
            </v-col>
        </v-row>
    </div>

</template>

<script>

  import FixtureItem from '@/components/FixtureItem';
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "Fixtures",
    props: ['week_id'],
    components: {
      FixtureItem
    },
    data: () => ({ }),
    computed: {
      ...mapGetters([
        'weekInfo',
        'weekGames',
        'weekTotalPoints'
      ]),
      weekGamesOne() {
        if (this.weekGames) {
          return this.weekGames.filter(game => game.game_num < 6);
        }
      },
      weekGamesTwo() {
        if (this.weekGames) {
          return this.weekGames.filter(game => game.game_num > 5);
        }
      }
    },
    methods: {
      ...mapActions([
        'getGames',
      ]),
    },
    watch: {
      week_id (newVal, oldVal) {
        this.getGames(this.week_id)
      }
    },
    created() {
      this.getGames(this.week_id)
    },
  }
</script>

<style scoped>

</style>
